<div class="mid-view-block">
  <app-view-block-buttons></app-view-block-buttons>
  <!--  <button class="travel-by-drone-btn">-->
  <!--    <i class="fas fa-plus"></i>-->
  <!--    <span class="travel-by-drone-btn-text"> Ajouter un drone SDIS30 </span>-->
  <!--  </button>-->
</div>
